import { ThunkDispatch } from 'redux-thunk';
import { RootState } from 'redux/store';
import { paramsI, roleFormApiInterface } from '../../../types/interface';
import { roleSlice } from './roleSlice';
import instance from 'utils/apiCalls';
import { ROLE_URLS } from './roleUrls';
import { Action } from '@reduxjs/toolkit';

const { actions } = roleSlice;
export const getAllRoles =
  (params: paramsI) =>
  async (
    dispatch: ThunkDispatch<RootState[keyof RootState], unknown, Action>
  ) => {
    const response = await instance.get(ROLE_URLS.GET_ALL_ROLE, { params });
    if (response?.data?.meta?.currentPage === 1) {
      dispatch(
        actions.setRoleTotalPages({
          totalPages: response?.data?.meta?.totalPages,
          totalRecords: response?.data?.meta?.totalRecords
        })
      );
    }
    return response;
  };

export const getAllModule = () => async () => {
  const response = await instance.get(`${ROLE_URLS.GET_ALL_MODULE}`);
  return response;
};

export const deleteRole = (id: number) => async () => {
  const response = await instance.delete(
    ROLE_URLS.DELETE_ROLE.replace(':id', id?.toString())
  );
  return response;
};

export const getSingleRole = (id: number) => async () => {
  const response = await instance.get(
    `${ROLE_URLS.GET_SINGLE_ROLE.replace(':id', id?.toString())}`
  );
  return response;
};

export const createRole = (data: roleFormApiInterface) => async () => {
  const response = await instance.post(`${ROLE_URLS.CREATE_ROLE}`, data);
  return response;
};

export const updateRole =
  (id: number, data: roleFormApiInterface) => async () => {
    const response = await instance.put(`${ROLE_URLS.UPDATE_ROLE}/${id}`, data);
    return response;
  };
